export const LazyVuetifyPlugin = {
    install (app) {
        let installation;

        app.config.globalProperties.$ensureVuetify = () => {
            installation ??= import('@portal/plugins/vuetify').then(({ default: vuetify }) => app.use(vuetify));

            return installation;
        };
    },
};
